import { z } from "zod";
import { whiteboardListItemSchema, whiteboardTitleSchema } from "@/lib/whiteboard/schema";

export const ADMIN_WHITEBOARD_PAGE_SIZE = 24;

export const adminWhiteboardSearchSchema = z.object({
  q: z.string().trim().max(200).optional().catch(undefined),
  projectId: z.string().min(1).max(64).optional().catch(undefined),
  external: z.enum(["active"]).optional().catch(undefined),
  page: z.coerce.number().int().min(1).max(100_000).optional().catch(undefined),
});

export type AdminWhiteboardSearch = z.infer<typeof adminWhiteboardSearchSchema>;

// Administration may change metadata, never the owner's drawing or identity.
export const adminWhiteboardUpdateSchema = z
  .strictObject({
    revision: z.number().int().positive(),
    title: whiteboardTitleSchema.optional(),
    projectId: z.string().trim().min(1).max(64).nullable().optional(),
  })
  .refine(
    (value) => value.title !== undefined || value.projectId !== undefined,
    "Aucune modification.",
  );

export type AdminWhiteboardUpdate = z.infer<typeof adminWhiteboardUpdateSchema>;

export const adminWhiteboardListItemSchema = whiteboardListItemSchema.omit({ access: true });

export type AdminWhiteboardListItem = z.infer<typeof adminWhiteboardListItemSchema>;

export const adminWhiteboardListSchema = z.object({
  items: z.array(adminWhiteboardListItemSchema),
  total: z.number().int().nonnegative(),
});
